import React, { useContext } from 'react'
import { useParams, Link } from 'react-router-dom';


import Heading2 from '../../../elements/titles/Heading2'
import Heading3 from '../../../elements/titles/Heading3'
import Paragraph from '../../../elements/p/Paragraph'
import Container from '../../../utils/Container'
import Button from '../../../elements/buttons/Button'
import AdminAside from '../admin/AdminAside'

import { FaWhatsapp } from 'react-icons/fa';
import { MdMailOutline } from 'react-icons/md';
import { BsArrowLeft } from 'react-icons/bs';
import { AiFillFilePdf } from 'react-icons/ai';

import contactsContext from "../../../../dataManager/contactsContext"


const AdminContent = () => {

     const { contacts } = useContext(contactsContext)

     const { contactId } = useParams()

     const contact = contacts.find(contact => contact.id === contactId)
     console.log(contact)

    return (
        <Container classe="mt-40">
            <Heading2 color="secondary" classe="uppercase">
                interface d'administration - rita nsangou
            </Heading2>

            <div className="adminContainer relative mr-10 mt-2">
                <AdminAside contacts={contacts} />

                <main className="mainAdmin flex flex-col space-y-3 px-4 pb-4"
                    style={{ overflowY: "hidden", maxHeight: "initial" }}
                >
                    

                    <Link to="/admin" className="flex space-x-1 items-center group cursor-pointer">
                        <BsArrowLeft size={20} color="#F35899" className="text-primary" />
                        <span className="group-hover:underline font-bold text-primary"> Toutes les démandes </span>
                    </Link>

                    <div className="flex flex-col space-y-5 p-4 bg-custom-gray rounded-md ">
                        <div className="">
                            <span className="font-bold text-secondary"> NOM & PRENOM </span>
                            <Paragraph color="secondary">
                                { contact.firstName } { contact.lastName}
                            </Paragraph>
                        </div>

                        <div className="">
                            <span className="font-bold text-secondary">EMAIL</span>
                            <Paragraph color="secondary">
                                { contact.email }
                            </Paragraph>
                        </div>

                        <div className="">
                            <span className="font-bold text-secondary">OBJECT</span>
                            <Paragraph color="secondary">
                                { contact.subject }
                            </Paragraph>
                        </div>

                        <div className="">
                            <span className="font-bold text-secondary">MESSAGE</span>
                            <Paragraph color="secondary">
                                { contact.message }
                            </Paragraph>
                        </div>

                        <div className="">
                            <span className="font-bold text-secondary">DATE D'ENVOIE</span>
                            <Paragraph color="secondary">
                               18/02/2022 à 17h 30 min
                            </Paragraph>
                        </div>
                    </div>

                    <div className="flex space-x-5 items-center">
                        <a 
                            href={`mailto:${contact.email}`}
                            className={`block p-2 text-white bg-primary rounded hover:opacity-80 cursor-pointer font-primary letter-spacing-loose`}
                        >
                            Repondre par mail
                        </a>

                        {
                            contact.file && <a href={contact.file} download target="_blanck" className="block cursor-pointer" >
                                        <AiFillFilePdf size="40" />
                                    </a>
                        }
                    </div>
                </main>
            </div>

        </Container>
    )
}

const ContactCard = ({ firstName, lastName, subject, message }) => {

    return(
        <article className="w-full bg-custom-gray p-5 rounded-md">
             <header className="flex justify-between items-center">
                 <span className="font-bold text-secondary">{`${firstName.toUpperCase()} ${lastName.toLowerCase()}`}</span>
                 <div className="flex space-x-5 items-center">
                    <FaWhatsapp size="20" color="#F35899" />
                    <MdMailOutline size="20" color="#F35899" />
                 </div>
             </header>
             <main className="flex justify-between items-center mt-3">
                 <div>
                    <h4 className="font-secondary font-semibold">{subject}</h4>
                    <p className="font-gray-100 mt-0.5">{message}</p>
                 </div>

                 <MdMailOutline size="40" color="#455A64" />
             </main>
        </article>
    )
}

export default AdminContent